/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from 'react';
import styles from './Follicular_Scan.module.css';
import { ThemeProvider } from '@emotion/react';
import {
  Button,
  MenuItem,
  TextField,
  Typography,
  IconButton,
  Grid2,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { theme } from '../../theme';
import { RequiredLabel } from '../../utils/commonUtils';
import { formatDateToLocalYYYYMMDD } from '../../services/time';
import {
  createFSDetailResults,
  fetchMedicalHistoryMasterData,
  FollicularStudyDetails,
  FollicularStudyResultsList,
  getFSDetailResults,
  RequestBodyFS,
} from './helper.stim';
import { useAlert } from '../../components/alertProvider';
import { isAxiosError } from 'axios';
import { useLocation } from 'react-router-dom';
import { DropdownOption, mapDropdownOptions } from '../../components/Medical_History_Forms/MenstrualHistory/MenstrualHistory.helpers';
import { useTranslation } from 'react-i18next';
import {ReactComponent as PrinterIcon} from '../../assets/SVG/printer.svg';
import FollicularScanReport from './StimulationsReport/FollicularScanReport';
import ReusableReportComponent from '../../components/printReports/ReusableReportComponent';

type FollicularDetails = {
  date: string;
  time: string;
  lmpDate: string;
  cycleDay: string;
  endometriumThickness?: string;
  ri?: string;
  psv?: string;
  endometriumMorphology?: string;
  endometrium_morphology_label?: string;
  cystLeftOvary?: string;
  cystRightOvary?: string;
  remark?: string;
  afcLeft?: string;
  afcRight?: string;
};

interface FolliculerProps {
  handleHormoneModalClose: () => void;
  date: Date;
  stim: number;
  lmp?: Date;
  cycleDay: number;
  id?: number;
  cycleStatus?: string;
  editable?: boolean;
}

const FollicularScan: React.FC<FolliculerProps> = ({
  handleHormoneModalClose,
  date,
  stim,
  lmp,
  cycleDay,
  id,
  cycleStatus,
  editable = true
}) => {
  const { state } = useLocation();
  const [record, setRecord] = useState<FollicularStudyResultsList | null>();
  const [mode, setMode] = useState<'view' | 'edit'>('edit');
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const { addAlert } = useAlert();
  const { t: tStimulation } = useTranslation('stimulation_config');
  const { t: tGeneral } = useTranslation('general');
  const [rows, setRows] = useState<number[]>([]);
  const [showPrint, setShowPrint] = useState<boolean>(false);
  
  const [folliclesData, setFolliclesData] = useState<{
    [key: number]: {
      leftSize: string;
      rightSize: string;
      leftFollicles: string;
      rightFollicles: string;
    };
  }>({});
  const [follicularDetails, setFollicularDetails] = useState<FollicularDetails>(
    {
      date: record?.date
        ? formatDateToLocalYYYYMMDD(new Date(record.date))
        : formatDateToLocalYYYYMMDD(date),
      time: record?.time || '',
      lmpDate: record?.lmp_date
        ? formatDateToLocalYYYYMMDD(new Date(record.lmp_date))
        : lmp
          ? formatDateToLocalYYYYMMDD(lmp)
          : formatDateToLocalYYYYMMDD(new Date()),
      cycleDay: record?.cycle_day || cycleDay.toString(),
      endometriumThickness: record?.endometrium_thickness || '',
      ri: record?.ri || '',
      psv: record?.psv || '',
      endometriumMorphology: record?.endometrium_morphology || '',
      endometrium_morphology_label: record?.endometrium_morphology_label || '',
      cystLeftOvary: record?.cyst_left_ovary || '',
      cystRightOvary: record?.cyst_right_ovary || '',
      remark: record?.remark || '',
      afcLeft: record?.left_afc_size || '',
      afcRight: record?.right_afc_size || '',
    }
  );
  const [dropdownOptionsForFollicular, setDropdownOptionsForFollicular] = useState<{
    endometrium_morphology: DropdownOption[];
  }>({
    endometrium_morphology: [],
  });

  // Track if any field has changed
  const [isDirty, setIsDirty] = useState(false);
  const [endometriumError, setEndometriumError] = useState<string | null>(null);

  useEffect(() => {
    fetchMedicalHistoryMasterData(
      'endometrium_morphology'
    )
      .then((response) => {
        setDropdownOptionsForFollicular({
          endometrium_morphology: mapDropdownOptions(response?.endometrium_morphology),

        });
      })
      .catch((err) => {
        console.error('Error fetching medical history masters', err);
      });
  }, []);

  useEffect(() => {
    if (record?.details && record.details.length > 0) {
      setRows(
        Array.from({ length: record.details.length }, (_, index) => index + 1)
      );
    } else {
      const savedRows = localStorage.getItem('follicularRows');
      if (savedRows) {
        setRows(JSON.parse(savedRows));
      } else {
        setRows([1, 2, 3, 4, 5]); // Default 5 rows if no saved rows or record
      }
    }
  },[record, date, lmp, cycleDay]);

  useEffect(() => {
    if (id && !id.toString().includes('mbsc')) {
      getFSDetailResults(id).then((result: FollicularStudyResultsList) =>
        setRecord(result)
      );
    }
  }, [id]);

  useEffect(() => {
    if (record?.id) {
      if(record?.details && record.details.length > 0) {
        setMode('view');
      }else {
        setMode('edit');
      }
      setFollicularDetails({
        date: record?.date
          ? formatDateToLocalYYYYMMDD(new Date(record.date))
          : formatDateToLocalYYYYMMDD(date),
        time: record?.time || '',
        lmpDate: record?.lmp_date
          ? formatDateToLocalYYYYMMDD(new Date(record.lmp_date))
          : lmp
            ? formatDateToLocalYYYYMMDD(lmp)
            : formatDateToLocalYYYYMMDD(new Date()),
        cycleDay: record?.cycle_day || cycleDay.toString(),
        endometriumThickness: record?.endometrium_thickness || '',
        ri: record?.ri || '',
        psv: record?.psv || '',
        endometriumMorphology: record?.endometrium_morphology || '',
        endometrium_morphology_label: record?.endometrium_morphology_label || '',
        cystLeftOvary: record?.cyst_left_ovary || '',
        cystRightOvary: record?.cyst_right_ovary || '',
        remark: record?.remark || '',
        afcLeft: record?.left_afc_size || '',
        afcRight: record?.right_afc_size || '',
      });
      const initialFolliclesData = record?.details?.reduce((acc: Record<number, {
        leftSize: string;
        rightSize: string;
        leftFollicles: string;
        rightFollicles: string;
      }>, detail: FollicularStudyDetails, index: number) => {
        acc[index + 1] = {
          leftSize: detail.left_follicle_size ?? '',
          rightSize: detail.right_follicle_size ?? '',
          leftFollicles: detail.left_no_of_follicles ?? '',
          rightFollicles: detail.right_no_of_follicles ?? ''
        };
        return acc;
      }, {});
      setFolliclesData(initialFolliclesData || {});
    }
  }, [record, date, lmp, cycleDay]);
  const toggleMode = () => {
    setMode((prev) => (prev === 'view' ? 'edit' : 'view'));
  };


  const addMoreRows = () => {
    const newRows = [
      ...rows,
      ...Array.from({ length: 5 }, (_, index) => rows.length + index + 1),
    ];
    setRows(newRows);
  };

  const deleteRow = (rowId: number) => {
    const updatedRows = rows.filter((row) => row !== rowId);
    setRows(updatedRows);

    const updatedFolliclesData = { ...folliclesData };
    delete updatedFolliclesData[rowId];
    setFolliclesData(updatedFolliclesData);
  };

  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};
    if (!follicularDetails.date) newErrors.date = 'Date is required.';
    if (!follicularDetails.time) newErrors.time = 'Time is required.';
    if (!follicularDetails.lmpDate) newErrors.lmpDate = 'LMP Date is required.';
    if (!follicularDetails.cycleDay)
      newErrors.cycleDay = 'Cycle Day is required.';

    // Removed validation for leftSize to make it optional
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (
    rowId: number,
    field: 'leftSize' | 'rightSize' | 'leftFollicles' | 'rightFollicles',
    value: string
  ) => {
    setFolliclesData((prev) => ({
      ...prev,
      [rowId]: {
        ...prev[rowId],
        [field]: value.replace(/[^0-9]/g, ''), // Allow only numeric values
      },
    }));
    setIsDirty(true);
  };

  const submitFollicularData = async () => {
    if (!validateForm()) {
      addAlert('Please fill the required fields', 'error');
      return;
    }

    const requestBody: RequestBodyFS = {
      stimulation_chart: stim.toString(),
      endometrium_thickness: follicularDetails.endometriumThickness || '0',
      date: follicularDetails.date,
      time: follicularDetails.time,
      ri: follicularDetails.ri,
      psv: follicularDetails.psv?.replace(/[^0-9.]/g, ''),
      endometrium_morphology: follicularDetails.endometriumMorphology || '',
      cyst_left_ovary: follicularDetails.cystLeftOvary,
      cyst_right_ovary: follicularDetails.cystRightOvary,
      left_afc_size: follicularDetails.afcLeft,
      right_afc_size: follicularDetails.afcRight,
      remark: follicularDetails.remark || '',
      details: rows
        .filter((rowId) => {
          const row = folliclesData[rowId];
          return (
            row?.leftSize ||
            row?.rightSize ||
            row?.leftFollicles ||
            row?.rightFollicles
          );
        })
        .map((rowId) => ({
          id: rowId,
          left_follicle_size: folliclesData[rowId]?.leftSize || '',
          right_follicle_size: folliclesData[rowId]?.rightSize || '',
          left_no_of_follicles: folliclesData[rowId]?.leftFollicles || '',
          right_no_of_follicles: folliclesData[rowId]?.rightFollicles || '',
        })),
    };

    try {
      await createFSDetailResults(requestBody);
      addAlert(tStimulation('Form has been updated successfully'), 'success');
      setMode('view');
      setTimeout(() => handleHormoneModalClose(), 300); // CLose Modal on Successful Save of Details
    } catch (error) {
      if (isAxiosError(error)) {
        error.response?.data.errors.forEach((err: any) => {
          addAlert(`${err.attr} : ${err.detail}`, 'error');
        });
      }
      console.error('Error saving follicular scan data:', error);
    }
  };

  const handleClose = () => {
    setShowPrint(false);
  };
  return (
    <div className="mt-4">
      <ThemeProvider theme={theme}>
        <div className={styles.container}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
            <span className={styles.headerText}>
              {tStimulation('follicularScan')}
            </span>
            <IconButton onClick={() => setShowPrint(true)} sx={{ marginTop: '8px' }}>
              <PrinterIcon />
            </IconButton>
            <ReusableReportComponent
              open={showPrint}
              onClose={handleClose}
              reportTitle={tGeneral('Follicular_Scan_Report')}
            >
              <FollicularScanReport 
                tStimulation={tStimulation}
                follicularDetails={follicularDetails}
                folliclesData={folliclesData}
                rows={rows} />
            </ReusableReportComponent>
          </div>
          <form>
            <Grid2 container spacing={2}>
              <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                {mode === 'view' ? (
                  <Typography variant="body1" className={styles.label}>
                    <label>{tStimulation('date')}</label>
                    <span>{follicularDetails.date}</span>
                  </Typography>
                ) : (
                  <TextField
                    fullWidth
                    size="small"
                    label={RequiredLabel(tStimulation('Date'), true)}
                    name="date"
                    type="date"
                    value={follicularDetails.date || ''}
                    onChange={(e) => {
                      setFollicularDetails((prev) => ({
                        ...prev,
                        date: e.target.value,
                      }));
                      setIsDirty(true);
                    }}
                    slotProps={{ inputLabel: { shrink: true } }}
                    error={!!errors.date}
                    helperText={errors.date}
                    disabled={true}
                  />
                )}
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                {mode === 'view' ? (
                  <Typography variant="body1" className={styles.label}>
                    <label>{tStimulation('time')}</label>
                    <span>{follicularDetails.time}</span>
                  </Typography>
                ) : (
                  <TextField
                    fullWidth
                    size="small"
                    label={RequiredLabel(tStimulation('time'), true)}
                    name="time"
                    type="time"
                    value={follicularDetails.time || ''}
                    onChange={(e) => {
                      setFollicularDetails((prev) => ({
                        ...prev,
                        time: e.target.value,
                      }));
                      setIsDirty(true);
                    }}
                    slotProps={{ inputLabel: { shrink: true } }}
                    error={!!errors.time}
                    helperText={errors.time}
                  />
                )}
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                {mode === 'view' ? (
                  <Typography variant="body1" className={styles.label}>
                    <label>{tStimulation('lmpDate')}</label>
                    <span>{follicularDetails.lmpDate}</span>
                  </Typography>
                ) : (
                  <TextField
                    fullWidth
                    size="small"
                    label={RequiredLabel(tStimulation('lmpDate'), true)}
                    name="lmpDate"
                    type="date"
                    value={follicularDetails.lmpDate || ''}
                    onChange={(e) => {
                      setFollicularDetails((prev) => ({
                        ...prev,
                        lmpDate: e.target.value,
                      }));
                      setIsDirty(true);
                    }}
                    slotProps={{ inputLabel: { shrink: true } }}
                    disabled={true}
                    error={!!errors.lmpDate}
                    helperText={errors.lmpDate}
                  />
                )}
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                {mode === 'view' ? (
                  <Typography variant="body1" className={styles.label}>
                    <label>{tStimulation('cycleDay')}</label>
                    <span>{follicularDetails.cycleDay}</span>
                  </Typography>
                ) : (
                  <TextField
                    fullWidth
                    size="small"
                    label={RequiredLabel(tStimulation('cycleDay'), true)}
                    name="cycleDay"
                    type="number"
                    value={follicularDetails.cycleDay || ''}
                    onChange={(e) => {
                      setFollicularDetails((prev) => ({
                        ...prev,
                        cycleDay: e.target.value.replace(/[^0-9]/g, ''),
                      }));
                      setIsDirty(true);
                    }}
                    slotProps={{ inputLabel: { shrink: true } }}
                    disabled={true}
                    error={!!errors.cycleDay}
                    helperText={errors.cycleDay}
                  />
                )}
              </Grid2>
            </Grid2>
          </form>

          <hr />
          {/* Follicular Scan Table */}
          <Grid2 container className={styles.tableEnteries}>
            <Grid2 size={{ xs: 6 }}>
              <Typography variant="h4" className={styles.tableHeader}>
                {tStimulation('leftOvary')}
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 6 }}>
              <Typography variant="h4" className={styles.tableHeader}>
                {tStimulation('rightOvary')}
              </Typography>
            </Grid2>
          </Grid2>
          <Grid2 container className={styles.tableEnteries}>
            <Grid2 size={{ xs: 2 }}>
              <Typography variant="h6">{tStimulation('follicularSize')}</Typography>
            </Grid2>
            <Grid2 size={{ xs: mode === 'view' ? 5 : 4 }}>
              <Typography variant="h6">{tStimulation('noOfFollicles')}</Typography>
            </Grid2>
            <Grid2 size={{ xs: 2 }}>
              <Typography variant="h6">{tStimulation('follicularSize')}</Typography>
            </Grid2>
            <Grid2 size={{ xs: 3 }}>
              <Typography variant="h6">{tStimulation('noOfFollicles')}</Typography>
            </Grid2>
            {mode !== 'view' && (
              <Grid2 size={{ xs: 1 }}>
                <Typography variant="h6">{tStimulation('action')}</Typography>
              </Grid2>
            )}
          </Grid2>
            
          {/* AFC Row - Only show when cycle day is 5 or less */}
          {parseInt(String(follicularDetails.cycleDay || '999'), 10) <= 5 && (
            mode === 'view' ? (
              <>
                <Grid2 container spacing={2} mt={2} alignItems="center" className={styles.tableEnteries}>
                  <Grid2 size={{ xs: 2 }}>
                    <Grid2 container spacing={1} alignItems="center">
                      <Grid2 size={{ xs: 'auto' }}>
                        <Typography variant="body1" fontWeight={500} sx={{marginLeft:1}}>
                          {(tStimulation('AfcLeft') || 'AFC (Left)') + ':'}
                        </Typography>
                      </Grid2>
                      <Grid2 size={{ xs: 6 }}>
                        <Typography variant="body1">
                          <span>{follicularDetails.afcLeft}</span>
                        </Typography>
                      </Grid2>
                    </Grid2>
                  </Grid2>
                  <Grid2 size={{ xs: 5 }}></Grid2>
                  <Grid2 size={{ xs: 2 }}>
                    <Grid2 container spacing={1} alignItems="center">
                      <Grid2 size={{ xs: 'auto' }}>
                        <Typography variant="body1" fontWeight={500}>
                          {(tStimulation('AfcRight') || 'AFC (Right)') + ':'}
                        </Typography>
                      </Grid2>
                      <Grid2 size={{ xs: 6 }}>
                        <Typography variant="body1">
                          <span>{follicularDetails.afcRight}</span>
                        </Typography>
                      </Grid2>
                    </Grid2>
                  </Grid2>
                  <Grid2 size={{ xs: 3 }}></Grid2>
                </Grid2>
                <hr />
              </>
            ) : (
              <>
                <Grid2 container spacing={2} mt={2} alignItems="center" className={styles.tableEnteries}>
                  <Grid2 size={{ xs: 6 }}>
                    <Grid2 container spacing={1} alignItems="center">
                      <Grid2 size={{ xs: 'auto' }}>
                        <Typography variant="body1" fontWeight={500}>
                          {tStimulation('AfcLeft') || 'AFC (Left)'}
                        </Typography>
                      </Grid2>
                      <Grid2 size={{ xs: 8 }}>
                        <TextField
                          fullWidth
                          size="small"
                          value={follicularDetails.afcLeft || ''}
                          onChange={(e) => {
                            setFollicularDetails((prev) => ({ ...prev, afcLeft: e.target.value }));
                            setIsDirty(true);
                          }}
                          inputProps={{ 'aria-label': tStimulation('AfcLeft') || 'AFC (Left)' }}
                        />
                      </Grid2>
                    </Grid2>
                  </Grid2>
                  <Grid2 size={{ xs: 6 }}>
                    <Grid2 container spacing={1} alignItems="center">
                      <Grid2 size={{ xs: 'auto' }}>
                        <Typography variant="body1" fontWeight={500}>
                          {tStimulation('AfcRight') || 'AFC (Right)'}
                        </Typography>
                      </Grid2>
                      <Grid2 size={{ xs: 8 }}>
                        <TextField
                          fullWidth
                          size="small"
                          value={follicularDetails.afcRight || ''}
                          onChange={(e) => {
                            setFollicularDetails((prev) => ({ ...prev, afcRight: e.target.value }));
                            setIsDirty(true);
                          }}
                          inputProps={{ 'aria-label': tStimulation('AfcRight') || 'AFC (Right)' }}
                        />
                      </Grid2>
                    </Grid2>
                  </Grid2>
                </Grid2>
                <hr />
              </>
            )
          )}

          <Grid2 container className={styles.tableEnteries}>
            <div className={styles.frows}>
              {rows.map((rowId) => (
                <Grid2
                  container
                  spacing={2}
                  key={rowId}
                  className={styles.inputRow}
                >
                  <Grid2 size={{ xs: 2 }}>
                    {mode === 'view' ? (
                      <Typography variant="body1" pl={1}>
                        <span>{folliclesData[rowId]?.leftSize}</span>
                      </Typography>
                    ) : (
                      <TextField
                        size="small"
                        placeholder={tStimulation('leftSize')}
                        value={folliclesData[rowId]?.leftSize || ''}
                        label={tStimulation('leftSize')}
                        onChange={(e) =>
                          handleInputChange(rowId, 'leftSize', e.target.value)
                        }
                      />
                    )}
                  </Grid2>
                  <Grid2 size={{ xs: mode === 'view' ? 5 : 4 }}>
                    {mode === 'view' ? (
                      <Typography variant="body1" pl={1}>
                        <span>{folliclesData[rowId]?.leftFollicles}</span>
                      </Typography>
                    ) : (
                      <TextField
                        size="small"
                        placeholder={tStimulation('leftFollicles')}
                        value={folliclesData[rowId]?.leftFollicles || ''}
                        onChange={(e) =>
                          handleInputChange(
                            rowId,
                            'leftFollicles',
                            e.target.value
                          )
                        }
                      />
                    )}
                  </Grid2>
                  <Grid2 size={{ xs: 2 }}>
                    {mode === 'view' ? (
                      <Typography variant="body1">
                        <span>{folliclesData[rowId]?.rightSize}</span>
                      </Typography>
                    ) : (
                      <TextField
                        size="small"
                        placeholder={tStimulation('rightSize')}
                        value={folliclesData[rowId]?.rightSize || ''}
                        onChange={(e) =>
                          handleInputChange(
                            rowId,
                            'rightSize',
                            e.target.value
                          )
                        }
                      />
                    )}
                  </Grid2>
                  <Grid2 size={{ xs: 3 }}>
                    {mode === 'view' ? (
                      <Typography variant="body1">
                        <span>{folliclesData[rowId]?.rightFollicles}</span>
                      </Typography>
                    ) : (
                      <TextField
                        size="small"
                        placeholder={tStimulation('rightFollicles')}
                        value={folliclesData[rowId]?.rightFollicles || ''}
                        onChange={(e) =>
                          handleInputChange(
                            rowId,
                            'rightFollicles',
                            e.target.value
                          )
                        }
                      />
                    )}
                  </Grid2>
                  {mode === 'edit' && (
                    <Grid2 size={{ xs: 1 }}>
                      <IconButton
                        color="error"
                        onClick={() => deleteRow(rowId)}
                        disabled={rows.length === 1}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Grid2>
                  )}
                </Grid2>
              ))}
            </div>
          </Grid2>

          <div className={styles.addMoreRows}>
            {mode === 'edit' && (
              <Button onClick={addMoreRows} style={{ textTransform: 'none' }}>
                {tStimulation('add5Rows')}
              </Button>
            )}
          </div>


          <Grid2 container spacing={2} mt={2}>
            {(mode === 'edit' || follicularDetails.endometriumThickness) && (
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                {mode === 'view' ? (
                  <Typography variant="body1" className={styles.label}>
                    <label>{tStimulation('endometriumThickness')}</label>
                    <span>{follicularDetails.endometriumThickness}</span>
                  </Typography>
                ) : (
                  <TextField
                    fullWidth
                    size="small"
                    label={RequiredLabel(tStimulation('endometriumThickness'), false)}
                    value={follicularDetails.endometriumThickness || ''}
                    error={!!endometriumError}
                    helperText={endometriumError}
                    onChange={(e) => {
                      const value = e.target.value;
                      setFollicularDetails((prev) => ({ ...prev, endometriumThickness: value }));
                      setIsDirty(true);
                      // Only validate if value is not empty and is a number
                      if (value && !isNaN(Number(value))) {
                        const num = Number(value);
                        if (num > 30) {
                          setEndometriumError(tStimulation('endometriumThicknessMax30'));
                        } else {
                          setEndometriumError(null);
                        }
                      } else {
                        setEndometriumError(null);
                      }
                    }}
                  />
                )}
              </Grid2>
            )}
            {(mode === 'edit' || follicularDetails.ri) && (
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                {mode === 'view' ? (
                  <Typography variant="body1" className={styles.label}>
                    <label>{tStimulation('ri')}</label>
                    <span>{follicularDetails.ri}</span>
                  </Typography>
                ) : (
                  <TextField
                    fullWidth
                    size="small"
                    label={RequiredLabel(tStimulation('ri'), false)}
                    value={follicularDetails.ri || ''}
                    onChange={(e) => {
                      setFollicularDetails((prev) => ({ ...prev, ri: e.target.value }));
                      setIsDirty(true);
                    }}
                  />
                )}
              </Grid2>
            )}
            {(mode === 'edit' || follicularDetails.psv) && (
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                {mode === 'view' ? (
                  <Typography variant="body1" className={styles.label}>
                    <label>{tStimulation('psv')}</label>
                    <span>{follicularDetails.psv}</span>
                  </Typography>
                ) : (
                  <TextField
                    fullWidth
                    size="small"
                    label={RequiredLabel(tStimulation('psv'), false)}
                    value={follicularDetails.psv || ''}
                    onChange={(e) => {
                      setFollicularDetails((prev) => ({ ...prev, psv: e.target.value }));
                      setIsDirty(true);
                    }}
                  />
                )}
              </Grid2>
            )}
            {(mode === 'edit' || follicularDetails.endometriumMorphology) && (
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                {mode === 'view' ? (
                  <Typography variant="body1" className={styles.label}>
                    <label>{tStimulation('endometriumMorphology')}</label>
                    <span>{follicularDetails.endometrium_morphology_label || follicularDetails.endometriumMorphology}</span>
                  </Typography>
                ) : (
                  <TextField
                    fullWidth
                    size="small"
                    name="endometrium_morphology"
                    select
                    label={RequiredLabel(tStimulation('endometriumMorphology'), false)}
                    value={follicularDetails.endometriumMorphology || ''}
                    onChange={(e) => {
                      const selected = dropdownOptionsForFollicular.endometrium_morphology.find(option => option.value === e.target.value);
                      setFollicularDetails((prev) => ({
                        ...prev,
                        endometriumMorphology: e.target.value,
                        endometrium_morphology_label: selected?.label || ''
                      }));
                      setIsDirty(true);
                    }}
                  >
                    {dropdownOptionsForFollicular.endometrium_morphology.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              </Grid2>
            )}
            {(mode === 'edit' || follicularDetails.cystLeftOvary) && (
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                {mode === 'view' ? (
                  <Typography variant="body1" className={styles.label}>
                    <label>{tStimulation('cystLeftOvary')}</label>
                    <span>{follicularDetails.cystLeftOvary}</span>
                  </Typography>
                ) : (
                  <TextField fullWidth size="small"
                    label={RequiredLabel(tStimulation('cystLeftOvary'), false)}
                    value={follicularDetails.cystLeftOvary || ''}
                    onChange={(e) => {
                      setFollicularDetails((prev) => ({ ...prev, cystLeftOvary: e.target.value }));
                      setIsDirty(true);
                    }} />
                )}
              </Grid2>
            )}
            {(mode === 'edit' || follicularDetails.cystRightOvary) && (
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                {mode === 'view' ? (
                  <Typography variant="body1" className={styles.label}>
                    <label>{tStimulation('cystRightOvary')}</label>
                    <span>{follicularDetails.cystRightOvary}</span>
                  </Typography>
                ) : (
                  <TextField fullWidth size="small"
                    label={RequiredLabel(tStimulation('cystRightOvary'), false)}
                    value={follicularDetails.cystRightOvary || ''}
                    onChange={(e) => {
                      setFollicularDetails((prev) => ({ ...prev, cystRightOvary: e.target.value }));
                      setIsDirty(true);
                    }} />
                )}
              </Grid2>
            )}
            {(mode === 'edit' || follicularDetails.remark) && (
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                {mode === 'view' ? (
                  <Typography variant="body1" className={styles.label}>
                    <label>{tStimulation('remark')}</label>
                    <span>{follicularDetails.remark}</span>
                  </Typography>
                ) : (
                  <TextField
                    fullWidth
                    size="small"
                    label={RequiredLabel(tStimulation('remark'), false)}
                    value={follicularDetails.remark || ''}
                    onChange={(e) => {
                      setFollicularDetails((prev) => ({ ...prev, remark: e.target.value }));
                      setIsDirty(true);
                    }} />
                )}
              </Grid2>
            )}
          </Grid2>
          {/* Existing logic for buttons and actions */}
          {/* <div
            className={styles.customButtonDiv}
            style={{ marginTop: '20px' }}
          >
            <Button
              variant="contained"
              className={styles.cancelButton}
              onClick={handleHormoneModalClose}
            >
              {tStimulation('close')}
            </Button>
            <span className={styles.saveBtnsDiv}>
              {JSON.stringify({ cycleStatus: cycleStatus, mode: mode, editable: record?.editable })}
             
              {(record?.editable === true && mode === 'view') && (
                <Button
                  variant="contained"
                  className={
                    mode === 'view'
                      ? styles.customButton
                      : styles.cancelButton
                  }
                  onClick={toggleMode}
                >
                  {mode === 'view' ? tStimulation('edit') : tStimulation('view')}
                </Button>
              )}
              {mode === 'edit' && (
                <Button
                  variant="contained"
                  className={styles.customButton}
                  onClick={submitFollicularData}
                >
                  {tStimulation('save')}
                </Button>
              )}
            </span>
          </div> */}

          <div
            className={styles.customButtonDiv}
            style={{ marginTop: '20px' }}
          >
            <Button
              variant="contained"
              className={styles.cancelButton}
              onClick={handleHormoneModalClose}
            >
              {tGeneral('Close')}
            </Button>
            <span className={styles.saveBtnsDiv}>
             
              {( cycleStatus === 'ACTIVE' && mode === 'view') && editable && (
                <Button
                  variant="contained"
                  className={
                    mode === 'view'
                      ? styles.customButton
                      : styles.cancelButton
                  }
                  onClick={toggleMode}
                >
                  {mode === 'view' ? tGeneral('edit') : tGeneral('View')}
                </Button>
              )}
              {mode === 'edit' && editable && (
                <Button
                  variant="contained"
                  className={styles.customButton}
                  onClick={submitFollicularData}
                  disabled={!isDirty || !!endometriumError}
                >
                  {tGeneral('Save')}
                </Button>
              )}
            </span>
          </div>
        </div>
      </ThemeProvider>
    </div>
  );
};

export default FollicularScan;